import {Injectable,Inject} from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import {LocalStorage} from 'ng2-webstorage';
import {Login} from '../../login/login.model';
import {Scheduler, Subscription, Observable} from 'rxjs';
import {LoginResponse} from '../../login/loginresponse.model';
import { DOCUMENT } from "@angular/platform-browser";
import * as moment from 'moment';
import { ContactUsResponse } from '../model/contact-us-response.model';

import { environment } from '../../../environments/environment';


@Injectable()
export class AuthService {

  private authenticated: boolean = false;
  private authenticatedOtp: boolean = false;
  private tokenExpirationDate: Date = null;
  @LocalStorage()
  private userData: any = null;
  @LocalStorage()
  private breezeSessionString: string;
  @LocalStorage()
  private tokenData: Oauth2TokenData;

  private refreshSub: Subscription;
  private loginResponse:LoginResponse;

  private localStorageVar = window.localStorage;

  private momentString: any;

  private localGroupId: number;

  private authCheck: boolean = false;

  private contactUsResponse: Observable<ContactUsResponse>;

  public static decodeAccessToken(access_token: string) {
    return JSON.parse(window.atob(access_token.split('.')[1]));
  }

  constructor(@Inject(DOCUMENT) private document,public http: Http) {
    if (this.tokenData && this.tokenData.access_token) {
      this.authenticated = true;
      this.userData = AuthService.decodeAccessToken(this.tokenData.access_token);

      if(localStorage.getItem('groupId')){
        this.localGroupId = +localStorage.getItem('groupId');
        console.log("groupID from local " + this.localGroupId  );
        this.getUserData().groupIds[0] = this.localGroupId;
      }

      //this.tokenExpirationDate = new Date(this.userData.exp * 30000);
    //   console.log('-----------------------------------------------------------');
    // if(this.authCheck){
       this.tokenExpirationDate = moment(this.userData.expTime).add(0, 'm').toDate();
       console.log('Session Local Storage const IN CONTRUCTOR OUTSIDE METHOD'+ localStorage.getItem('expiryTime'));
       if(this.tokenExpirationDate != null && localStorage.getItem('expiryTime') != undefined){

          if(moment(localStorage.getItem('expiryTime')).toDate() > new Date() ){
            this.momentString = "";
            this.momentString = moment(localStorage.getItem('expiryTime')).add(30, 'm').toDate();

            this.tokenExpirationDate = this.momentString;
            
            localStorage.setItem('expiryTime', this.momentString.toString());
            console.log('Session Local Storage const IN CONTRUCTOR INSIDE METHOD PASSING IF SETTER '+ localStorage.getItem('expiryTime'));
          }
         
          this.tokenExpirationDate = moment(localStorage.getItem('expiryTime')).toDate();
          console.log('Session Local Storage const IN CONTRUCTOR INSIDE METHOD'+ localStorage.getItem('expiryTime'));
          console.log('Session token const IN CONTRUCTOR INSIDE METHOD'+ this.tokenExpirationDate);
       }

          console.log('Session ORGINAL DATE const TOKEN EXPRIY IN CONTRUCTOR'+ this.tokenExpirationDate);
          console.log('Session ORGINAL DATE const TOKEN EXPRIY IN CONTRUCTOR'+ this.authCheck);
          console.log('-----------------------------------------------------------');
         if (this.authenticated && (this.tokenExpirationDate < new Date() ) ) {
        console.log('Session timeout');
        this.logout();
      }else {
        this.refreshTokenNew();
       // this.scheduleTokenRefresh();
      }
    }
  }

  public isAuthenticated(): boolean {
    this.checkTokenExpirationDate();
    return this.authenticated;
  }

  public authenticate(username: string, password: string): Promise<string> {

    console.log('Authentication pending...');

    return new Promise<string>((resolve, reject) => {

      if (!username.trim()) {
        reject('Username cannot be blank');
      }
      if (!password.trim()) {
        reject('Password cannot be blank');
      }

      var basicAuthHeader = btoa(`acme:acmesecret`);

      var headers = new Headers();
      headers.append('Authorization', `Basic  ${basicAuthHeader}`);
      headers.append('Accept', `application/json`);
      headers.append('Content-Type', `application/x-www-form-urlencoded; charset=utf-8`);

      var data = 'username=' + encodeURIComponent(username) + '&password='
        + encodeURIComponent(password) + '&grant_type=password';

      this.http
        .post('/oauth/token', data, {headers: headers})
        .subscribe(
          data => {
            this.tokenData = data.json();
            this.authenticated = true;
            this.userData = AuthService.decodeAccessToken(this.tokenData.access_token);
            console.log(this.userData);
            
            if(this.userData.userStatus == 'suspended'){
              reject('User account is suspended and cannot access this system');
            }
            else if( environment.bannerGroups.includes(this.userData.groupIds[0]) )
            {
              //this.tokenExpirationDate = new Date(this.userData.expTime * 30000);
              //this.tokenExpirationDate = new Date(this.userData.exp * 30000);
           //   console.log('-----------------------------------------------------------');
              this.tokenExpirationDate = moment(new Date()).add(30, 'm').toDate();
              this.userData.expTime =moment(new Date()).add(30, 'm').toDate();

           //   console.log('Session ORGINAL DATE  auth + 30000'+ this.tokenExpirationDate);
              localStorage.setItem('expiryTime', this.tokenExpirationDate.toString());
           //   console.log('Session Local Storage const IN AUTH '+ localStorage.getItem('expiryTime'));
           //   console.log('Session token const IN AUTH'+ this.tokenExpirationDate);
          //    console.log('-----------------------------------------------------------');
      
              //this.scheduleTokenRefresh();
              resolve('OK');
              this.authCheck = true;
            }else if(this.userData.groupIds[0]== 23573){
              reject('Please use the following link to access your Ako Ātea site. (<a href="https://learn.access.org.nz/login">learn.access.org.nz</a>)');
            }else{
              reject('User does not have access to this system');
            }

          },
          err => {
            console.log(err);
            reject('Username and password doesn\'t match');
          }
        );

    });
  }
  public authenticateBreeze(loginModel:Login): Promise<string> {

    console.log('Inside BreezeCOnnection');

      return new Promise<string>((resolve, reject) => {
        if (!loginModel.userName.trim()) {
        reject('Username cannot be blank');
      }
      if (!loginModel.password.trim()) {
        reject('Password cannot be blank');
      }
      let data = JSON.stringify(loginModel);
// var data = 'username=' + encodeURIComponent(username) + '&password='
//         + encodeURIComponent(password) + '&grant_type=password';
//var headers = new Headers();
//headers.append('Accept', `application/json`);
 this.http
        .post('/api/breezeAuthentication/login', data, { headers: new Headers({ 'Content-Type': 'application/json' })})
         .subscribe(
          data => {
            this.loginResponse = data.json();

                

            

                  this.breezeSessionString =  this.loginResponse.breezSessionString;
                  this.userData.breezeSessionString =  this.breezeSessionString;
                  console.log("breezeSessionString " + this.userData.breezeSessionString);
                  console.log(this.userData);
                  document.cookie = 'cookieBreezeSession='+this.breezeSessionString+'; expires=Tue, 20 Sept 2022 00:00:00 UTC; path=/';
                  resolve('OK');
          
              

                  
          }, err => {
            console.log(err);
            reject('Username and password doesn\'t match');
          }
        );
 });
  }

  private scheduleTokenRefresh() {
    let now: number = new Date().valueOf();
    let delay: number = ((this.userData.exp * 1000) - now) - 1000;

    console.log('Calculated delay is: ' + delay);

    if (this.refreshSub && !this.refreshSub.closed) {
      this.refreshSub.unsubscribe();
    }

    this.refreshSub = Scheduler.async.schedule(() => {
      console.log('Refreshing token...');
      this.refreshToken();
    }, delay);

    //this.tokenData.expires_in
  }

  public refreshToken() {
    if (this.isAuthenticated()) {

      var basicAuthHeader = btoa(`acme:acmesecret`);

      var headers = new Headers();
      headers.append('Authorization', `Basic  ${basicAuthHeader}`);
      headers.append('Accept', `application/json`);
      headers.append('Content-Type', `application/x-www-form-urlencoded`);

      var data = 'grant_type=refresh_token&refresh_token=' + encodeURIComponent(this.tokenData.refresh_token);

      this.http
        .post('/oauth/token', data, {headers: headers})
        .subscribe(
          data => {
            this.tokenData = data.json();
            this.authenticated = true;
            this.userData = AuthService.decodeAccessToken(this.tokenData.access_token);
            this.tokenExpirationDate = new Date(this.userData.expTime * 1000);
            console.log("Token REFRESHED + " + this.tokenExpirationDate);
            //this.scheduleTokenRefresh();
          },
          err => {
            console.log(err);
          }
        );
    }
  }

  public logout(): any {
    if (this.refreshSub && !this.refreshSub.closed) {
      this.refreshSub.unsubscribe();
    }
    this.tokenData = new Oauth2TokenData();
    this.userData = null;
    this.authenticated = false;
    this.tokenExpirationDate = null;
    this.authCheck = false;

    if(environment.baseSystem == 'self'){

      this.document.getElementById('appcss').setAttribute('href', '/scss/app_sigma.css');
      this.document.getElementById('customcss').setAttribute('href', '/scss/custom_sigma.css');
      this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_sigma.css');
      this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_sigma.css');

    }else if(environment.baseSystem == 'access'){
      this.document.getElementById('appcss').setAttribute('href', '/scss/app_access.css');
      this.document.getElementById('customcss').setAttribute('href', '/scss/custom_access.css');
      this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_access.css');
      this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_access.css');
    }
  


  }

  public getUserData(): any {
    return this.userData;
  }
  public getBreezeSessionString():string{
    return this.breezeSessionString;
  }
  public getTokenExpirationDate(): Date {
    return this.tokenExpirationDate;
  }

  public getAuthCheck(): boolean{
    return this.authCheck;
  }

  public hasRole(role: string): boolean {
    if (this.isAuthenticated()) {
      return this.getUserData()['authorities'].indexOf(role) >= 0;
    }
    return false;
  }

  public hasAnyRole(roles: string[]): boolean {
    var ok = false;
    roles.forEach(role => {
      if (this.hasRole(role)) {
        ok = true;
      }
    });
    return ok;
  }


  public setUserDataView(view: number): any {
    this.getUserData().groupIds[0] = view;
    localStorage.setItem('groupId', view.toString());
    console.log("local groupID setting " + localStorage.getItem('groupId').toString());
    window.location.reload();
  }

  // public canView(view: AppMenuItem): boolean {
  //   var ok = false;
  //   if (!view.roles) {
  //     ok = true;
  //   } else {
  //     ok = this.hasAnyRole(view.roles);
  //   }
  //   return ok;
  // }

  public getAuthorizationHeaders(): Headers {
    var authorizationHeaders = new Headers();
    if (this.authenticated) {
      authorizationHeaders.append('Authorization', `Bearer ${this.tokenData.access_token}`);
    }
    return authorizationHeaders;
  }

  private checkTokenExpirationDate() {
    //console.log('TOKEN EXPIRY CHECK timeout Date ' + this.tokenExpirationDate + ' Current Date ' + new Date());
    if (this.authenticated && this.tokenExpirationDate < new Date()) {
      console.log('Session timeout');
      this.logout();
    }
  }

  private fetchUserData() {
    this.http.get('/api/user', {headers: this.getAuthorizationHeaders()})
      .subscribe(
        data => {
          this.userData = data.json();
        },
        err => this.authenticated = false
      );
  }

  public refreshTokenNew(){

    if (this.authenticated ){
      this.updateToken();
    }
  }
  private updateToken(){
    this.tokenExpirationDate = moment(new Date()).add(30, 'm').toDate();
    this.userData.expTime = moment(new Date()).add(30, 'm').toDate();



      localStorage.setItem('expiryTime', this.tokenExpirationDate.toString());
      //this.tokenExpirationDate = moment(localStorage.getItem('expiryTime')).toDate();
 //     console.log('Session Local Storage const IN UPDATE '+ localStorage.getItem('expiryTime'));
   //   console.log('Session token const IN UPDATE'+ this.tokenExpirationDate);
    //  console.log('Session ORGINAL DATE + Update Token'+ moment(new Date()).add(30, 'm').toDate());
  }


  public authenticateBreezeAdmin(loginModel:Login): Promise<string> {

    return new Promise<string>((resolve, reject) => {
      if (!loginModel.userName.trim()) {
      reject('Username cannot be blank');
    }
    let data = JSON.stringify(loginModel);
// var data = 'username=' + encodeURIComponent(username) + '&password='
//         + encodeURIComponent(password) + '&grant_type=password';
//var headers = new Headers();
//headers.append('Accept', `application/json`);
this.http
      .post('/api/breezeAuthentication/loginAdmin', data, { headers: new Headers({ 'Content-Type': 'application/json' })})
       .subscribe(
        data => {
          this.loginResponse = data.json();
                this.breezeSessionString =  this.loginResponse.breezSessionString;
                this.userData.breezeSessionString =  this.breezeSessionString;
                console.log("breezeSessionString " + this.userData.breezeSessionString);
                console.log(this.userData);
                resolve('OK');
        }, err => {
          console.log(err);
          reject('Username and password doesn\'t match');
        }
      );
});
}


public changePassword(loginModel):Observable<ContactUsResponse>{

  let params: URLSearchParams = new URLSearchParams();
  let bodyString = JSON.stringify(loginModel);
  console.log(bodyString);

  return this.http.post('/api/account/updatePasswordFix/', bodyString,  {
    headers: new Headers({ 'Content-Type': 'application/json' })})
    .map((res: Response) => res.json())
    ;

}



 authenticateBreezeCheckPass(loginModel:Login): Observable<ContactUsResponse> {

  console.log('Inside authenticateBreezeCheckPass');

    
      if (!loginModel.userName.trim()) {
      
    }
    if (!loginModel.password.trim()) {
      
    }
    let data = JSON.stringify(loginModel);

    return this.http.post('/api/account/checkPass', data,  {
      headers: new Headers({ 'Content-Type': 'application/json' })})
      .map((res: Response) => res.json())
      ;




}  

public authenticateOtp(username: string, password: string): Promise<string> {

  

  return new Promise<string>((resolve, reject) => {

    if (!username.trim()) {
      reject('Username cannot be blank');
    }
    if (!password.trim()) {
      reject('Password cannot be blank');
    }

    var basicAuthHeader = btoa(`acme:acmesecret`);

    var headers = new Headers();
    headers.append('Authorization', `Basic  ${basicAuthHeader}`);
    headers.append('Accept', `application/json`);
    headers.append('Content-Type', `application/x-www-form-urlencoded; charset=utf-8`);

    var data = 'username=' + encodeURIComponent(username) + '&password='
      + encodeURIComponent(password) + '&grant_type=password';

    this.http
      .post('/oauth/token', data, {headers: headers})
      .subscribe(
        data => {
          let tokenDataOtp = data.json();
          let userDataOtp= AuthService.decodeAccessToken(tokenDataOtp.access_token);
          console.log(userDataOtp);
          
          if(userDataOtp.userStatus == 'suspended'){
            reject('User account is suspended and cannot access this system');
          }
          else if( environment.bannerGroups.includes(userDataOtp.groupIds[0]) )
          {
            //Redirect to OTP page
            localStorage.setItem('username',username);
            localStorage.setItem('password',password);
            this.authenticatedOtp = true;
            resolve('OK');
          }else{
            reject('User does not have access to this system');
          }

        },
        err => {
          console.log(err);
          reject('Username and password doesn\'t match');
        }
      );

  });
}
public isAuthenticatedOtp(): boolean {

  return this.authenticatedOtp;
}

verifyOtp(){


    //this.tokenExpirationDate = new Date(this.userData.expTime * 30000);
            //this.tokenExpirationDate = new Date(this.userData.exp * 30000);
            console.log('-----------------------------------------------------------');
            this.tokenExpirationDate = moment(new Date()).add(30, 'm').toDate();
            this.userData.expTime =moment(new Date()).add(30, 'm').toDate();

            console.log('Session ORGINAL DATE  auth + 30000'+ this.tokenExpirationDate);
            localStorage.setItem('expiryTime', this.tokenExpirationDate.toString());
            console.log('Session Local Storage const IN AUTH '+ localStorage.getItem('expiryTime'));
            console.log('Session token const IN AUTH'+ this.tokenExpirationDate);
            console.log('-----------------------------------------------------------');
    
            //this.scheduleTokenRefresh();
          //  resolve('OK');
            this.authCheck = true;
}



}

class Oauth2TokenData {
  access_token: string = null;
  token_type: string = null;
  expires_in: number = null;
  scope: string = null;
  jti: string = null;
  refresh_token: string = null;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.service.ts